import React, { useState, useEffect } from "react";
import Carousel from "../../Carousel/imageCarosel/ImageCarousel";
import { aboutImg, imgURL } from "../../Config";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

const AboutUs = ({ aboutData }) => {
  const [shortDescHTML, setShortDescHTML] = useState({
    id: "",
    desc: "",
  });
  const [slides, setSlides] = useState(aboutImg);

  useEffect(() => {
    // Simulate API fetch with local data
    try {
      const description = aboutData[0]?.description || "Data not found";
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = description;
      const paragraphs = Array.from(tempDiv.querySelectorAll("p"));
      let initialLines = "";
      for (let i = 0; i < Math.min(1, paragraphs.length); i++) {
        initialLines += `${paragraphs[i].textContent}`;
      }
      let desc = (
        <p
          className="about-one__text"
          data-wow-duration="1500ms"
          data-wow-delay="300ms"
          dangerouslySetInnerHTML={{ __html: initialLines }}
        />
      );
      setShortDescHTML({ id: aboutData[0].id, desc: desc });
      const images = aboutData[0].images.map((m) => {
        return `${imgURL}diversionary_image/${m.diversionary_image}`;
      });
      setSlides(images);
    } catch (error) {
      const desc = (
        <p
          className="about-one__text"
          data-wow-duration="1500ms"
          data-wow-delay="300ms"
        >
          Data not found
        </p>
      );
      setShortDescHTML({ desc: desc });
      setSlides(aboutImg);
      Swal.fire({
        title: "Error",
        text: error?.response?.data?.message || error?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  }, []);

  if (shortDescHTML.error) {
    return (
      <div className="alert alert-danger my-4" role="alert">
        {shortDescHTML.error}
      </div>
    );
  }

  return (
    <section className="about-one pt-60 pb-100">
      <div className="container">
        <div className="row gutter-y-30 align-items-center">
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div
              className="about-one__content wow fadeInLeft"
              data-wow-duration="1500ms"
              data-wow-delay="300ms"
            >
              <div className="sec-title">
                <h3 className="sec-title__title">About</h3>

                <h4 className="sec-title__tagline justify-content-start">
                  The Diversionary Trajectory{" "}
                </h4>
              </div>
              {shortDescHTML.desc}
              <div
                className="about-one__btn"
                data-wow-duration="1500ms"
                data-wow-delay="300ms"
              >
                <Link to='/about' className="acwadam-btn acwadam-btn--base">Read More</Link>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div
              className="about-one__thumb wow fadeInRight"
              data-wow-duration="1500ms"
              data-wow-delay="300ms"
            >
              <div className="about-one__thumb__item">
                <Carousel
                  slides={slides}
                  showOverlay={false}
                  overlayContent={null}
                  showIndicators={false}
                  showWavyBorder={false}
                  specificClassName="aboutusRadius"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
